export default __webpack_public_path__ + "static/media/LogoPos.1a39672c.png";